/**
 * setDocumentDir utility module.
 * Provides a function to set the document's text direction (RTL or LTR) and update the root element's class accordingly based on the language code.
 */

const RTL_LANGS = ["he", "ar"];

/**
 * Sets the document's direction (dir attribute and class) based on the language code.
 * Adds either 'rtl' or 'ltr' class to <html> and updates the dir attribute.
 *
 * @param {string} lang - The language code (e.g., 'he', 'en', 'ar').
 */
export default function setDocumentDir(lang) {
  const dir = RTL_LANGS.includes(lang) ? "rtl" : "ltr";
  // Only update if the direction has changed
  if (document.documentElement.dir !== dir) {
    document.documentElement.dir = dir;
    document.documentElement.classList.remove("rtl", "ltr");
    document.documentElement.classList.add(dir);
  }
}
